module.exports = __webpack_public_path__ + "img/eyes_close.6703e33e.svg";